import type { FC } from 'react';
import { IconButton, SvgIcon, SxProps, Typography } from '@mui/material';

import EditIcon from '../../icons/EditV2.svg';
import ProfileCircleOutlinedIcon from '../../icons/ProfileCircleOutlinedIcon.svg';

import { Root } from './styled';

export interface IEnteredEmailFieldProps {
	email: string;
	onEditClick?: VoidFunction;
	sx?: SxProps;
}

export const UserEmailWithEdit: FC<IEnteredEmailFieldProps> = ({
	email,
	onEditClick,
	sx,
}) => {
	return (
		<Root sx={sx}>
			<ProfileCircleOutlinedIcon />
			<Typography color="primary.main" variant="body2" noWrap>
				{email}
			</Typography>
			{onEditClick && (
				<IconButton color="primary" onClick={onEditClick} sx={{ ml: 'auto' }}>
					<SvgIcon component={EditIcon} inheritViewBox />
				</IconButton>
			)}
		</Root>
	);
};
